<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-menu
        :nudge-bottom="5"
        offset-y
        :close-on-content-click="false">
        <template v-slot:activator="{ on: menuOn, attrs: menuAttrs }">
          <v-icon
            class="pointer"
            color="black"
            v-bind="{ ...attrs, ...menuAttrs }"
            v-on="{ ...on, ...menuOn }">
            mdi-undo
          </v-icon>
        </template>
        <v-list
          v-if="undoActionsLength"
          style="max-height: 500px; overflow-y: auto;">
          <v-list-item
            v-for="(action, index) in undoActionsList"
            :key="index">
            <span
              class=" fs-14 mr-2">
              {{ getDescForUndoAction(action) }}
            </span>
            <span
              v-if="action.col"
              class="fs-12 text-caption text-grey-lighten-1">
              - {{ action.col }}
            </span>
          </v-list-item>
        </v-list>
        <div
          v-else
          class="pa-6 fs-16 white">
          No Actions
        </div>
        <div class="pa-2 pt-0 mt-n2 d-flex justify-center white">
          <v-btn
            class="white--text"
            color="black"
            :loading="isUndoing"
            :disabled="!undoActionsLength || isUndoing"
            @click="undoLatestAction">
            <v-icon color="white">
              mdi-undo
            </v-icon>
            Undo
          </v-btn>
        </div>
      </v-menu>
    </template>
    <span>Undo History</span>
  </v-tooltip>
</template>

<script>
import {
  mapState,
  mapGetters,
  mapActions,
} from 'vuex';
import {
  SCHEDULE_UPDATE_CELL,
  SCHEDULE_DELETE_ROW,
  SCHEDULE_RESTORE_ROWS,
} from '@/constants/undoActions';

export default {
  name: 'UndoHistory',
  data: () => ({
    SCHEDULE_UPDATE_CELL,
    SCHEDULE_DELETE_ROW,
    SCHEDULE_RESTORE_ROWS,
  }),
  computed: {
    ...mapState('UndoActions', ['isUndoing', 'undoActions']),
    ...mapGetters('UndoActions', ['undoActionsLength']),
    undoActionsList() {
      const projectId = this.$route.params.id;
      return this.undoActions.filter((a) => a.projectId === projectId);
    },
  },
  methods: {
    ...mapActions('UndoActions', ['undoHandleAction']),
    getDescForUndoAction(action) {
      if (!action) return '';

      if (action.action === SCHEDULE_UPDATE_CELL) {
        return 'Updated';
      }
      if (action.action === SCHEDULE_DELETE_ROW) {
        return 'Added row';
      }
      if (action.action === SCHEDULE_RESTORE_ROWS) {
        return 'Deleted row';
      }

      return '';
    },
    undoLatestAction() {
      this.undoHandleAction();
    },
  },
};
</script>

<style scoped lang="scss">
</style>